import { useEffect, useRef } from 'react';
import { useTasksJobs } from '../../hooks/useTasksJobs';
import { useTasksDrawer } from '../../tasksDrawerStore';
export function useAutoOpenDrawer() {
    const { tasks, isSettled } = useTasksJobs();
    const { setIsDrawerOpen } = useTasksDrawer();
    const tasksLength = tasks.length;
    const baselineSetRef = useRef(false);
    const previousLengthRef = useRef(0);
    useEffect(()=>{
        if (!isSettled) return;
        if (!baselineSetRef.current) {
            baselineSetRef.current = true;
            previousLengthRef.current = tasksLength;
            return;
        }
        const previousLength = previousLengthRef.current;
        previousLengthRef.current = tasksLength;
        if (tasksLength > previousLength) {
            setIsDrawerOpen(true);
        }
    }, [
        tasksLength,
        isSettled,
        setIsDrawerOpen
    ]);
}
